export const tourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: false,
    },
    canClickTarget: false,
    scrollTo: false,
    classes: 'chooose-onboarding',
    popperOptions: {
      modifiers: [{ name: 'offset', options: { offset: [0, 30] } }],
    },
  },
  useModalOverlay: true,
};

export const steps = [];
